export enum Role {
  Admin = "Admin",
  Tech = "Tech",
  OfficeStaff = "OfficeStaff",
}
